import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AuthState } from '../types';

const initialState: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  name: null,
  org_access_token: null,
  user_refresh_token: null,
  selected_org_id: null,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (
      state,
      action: PayloadAction<{
        name?: string;
        org_access_token?: string;
        user_refresh_token?: string;
        selected_org_id?: string;
      }>
    ) => {
      const { name, org_access_token, user_refresh_token, selected_org_id } = action.payload;

      if (name !== undefined) state.name = name;
      if (org_access_token !== undefined) state.org_access_token = org_access_token;
      if (user_refresh_token !== undefined) state.user_refresh_token = user_refresh_token;
      if (selected_org_id !== undefined) state.selected_org_id = selected_org_id;

      state.isAuthenticated = !!org_access_token;
      state.isLoading = false;
      state.error = null;
    },

    setOrgAccessToken: (state, action: PayloadAction<string>) => {
      state.org_access_token = action.payload;
      state.isAuthenticated = !!action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },

    clearAuth: (state) => {
      state.isAuthenticated = false;
      state.isLoading = false;
      state.name = null;
      state.org_access_token = null;
      state.user_refresh_token = null;
      state.selected_org_id = null;
      state.error = null;
    },
  },
});

export const { setAuthData, setOrgAccessToken, setLoading, setError, clearAuth } =
  authSlice.actions;

export default authSlice.reducer;
